import React from 'react';
import ProductOverview from '../../product-overview/ProductOverview';
import product from '../all-gear.json';

const WomensAdidasPolo = () => {
	return (
		<React.Fragment>
			<ProductOverview
				name={product.allGear[20].productName}
				color={product.allGear[20].color}
				size={product.allGear[20].sizes}
				price={product.allGear[20].price}
				img={product.allGear[20].img}
				miniImg1={product.allGear[20].miniImg1}
				miniImg2={product.allGear[20].miniImg2}
				miniImg3={product.allGear[20].miniImg3}
			/>
		</React.Fragment>
	);
};

export default WomensAdidasPolo;
